<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import SystemSettingsItem from './system-settings-item'
import SystemSettingsItemNew from './system-settings-item-new'
import TablePaginator from '@components/paginator'
import {cloneDeep} from "lodash";

export default {
  name: 'SystemSettings',
  components: {
    Layout,
    SystemSettingsItem,
    SystemSettingsItemNew,
    TablePaginator,
  },
  props: {
    dictionary: {
      type: Object,
      default: () => {
        return Object
      },
    },
  },
  data() {
    return {
      isLoading: false,
      rowsPerPage: [10, 25, 50],
      page: 1,
      totalPages: 0,
      sortBy: 'translatedName',
      descending: false,
      first: false,
      last: false,
      pagination: {},
      currentItem: {},
      editItem: false,
      newItem: false,
    }
  },
  computed: {
    content(){
      return this.dictionary.content.map(item =>  {
        item.translatedName = this.$t(this.$route.params.dictionaryName + '.' + item.code + ".name")
        item.translatedDescription = this.$t(this.$route.params.dictionaryName + '.' + item.code + ".description")
        return item
      })
    },
    headers() {
      const defaultHeader = [
        { text: 'name', value: 'translatedName', sortable: true },
        { text: 'description', value: 'translatedDescription', sortable: true },
      ]
      const documenttypeHeader = [
        { text: 'name', value: 'translatedName', sortable: true },
        { text: 'activity_type', value: 'operationType', sortable: true },
        { text: 'description', value: 'translatedDescription', sortable: true },
      ]
      const alertanalyzersettingsHeader = [
        { text: 'name', value: 'name', sortable: true },
        { text: 'value', value: 'value', sortable: true },
      ]
      switch (this.$route.params.dictionaryName) {
        case 'documenttype':
          return documenttypeHeader
        case 'alertanalyzersettings':
          return alertanalyzersettingsHeader
        default:
          return defaultHeader
      }
    },
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.page || null,
        sort_property: this.sortBy || null,
        sort_direction: this.descending || null,
      }
    },
  },
  created() {
    this.getPaginator()
  },
  methods: {
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    openItem(item) {
      this.currentItem = item
      this.editItem = true
    },
    closeItem() {
      this.editItem = false
    },
    getPaginator() {
      const pagination = this.$store.getters['pagination/get'](this.$route.params.dictionaryNameName)
      if (pagination) {
        this.pagination.page = pagination.page || 1
        this.pagination.sortBy = pagination.sortBy || this.sortBy
        this.pagination.descending = pagination.descending || this.descending
        this.pagination.rowsPerPage = pagination.rowsPerPage || 10
      } else {
        this.pagination.page = 1
        this.pagination.rowsPerPage = 10
      }
    },
    onPaginationChange(pagination) {
      this.pagination.page = pagination.page
      this.pagination.sortBy = pagination.sortBy
      this.pagination.descending = pagination.descending
      this.pagination.rowsPerPage = pagination.rowsPerPage
      this.$store.commit('pagination/SET', {
        name: this.$route.params.dictionaryNameName,
        pagination: cloneDeep(this.pagination),
      })
    },
  },
}
</script>

<template>
  <Layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination.sync="pagination"
      :loading="isLoading"
      :class="$style.sdTable"
      :rows-per-page-items="rowsPerPage"
      @update:pagination="onPaginationChange"
    >
      <template
        slot="headerCell"
        slot-scope="props">
        {{ $t(`label__${props.header.text}`) }}
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :class="$style.sdEditRow"
          @click="openItem(props.item)"
        >
          <td v-if="$route.params.dictionaryName === 'alertanalyzersettings'">
            {{ props.item.name }}
          </td>
          <td v-else>{{ props.item.translatedName }}</td>
          <td
            v-if="$route.params.dictionaryName === 'documenttype'"
          >{{ $t('operationtype.'+props.item.operationType+'.name') }}</td>
          <td
            v-if="$route.params.dictionaryName === 'alertanalyzersettings'"
          >{{ props.item.value }}</td>
          <td v-else>{{ props.item.translatedDescription }}</td>
        </tr>
      </template>
    </v-data-table>
    <system-settings-item
      :dialog="editItem"
      :item="currentItem"
      @close-dialog="closeItem"
    />
    <system-settings-item-new
      :dialog="newItem"
      @close-item-new="newItem = false"
    />
  </layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }
}
.sdEditRow {
  cursor: pointer;
}
</style>
